import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SummarySectionTitle from './Component/SummarySectionTitle';
import SummaryFeature from './Component/SummaryFeature';
import { changeIsSummaryOpened, initializeSections } from '../../model/configuratorSlice';
import { CloseButton, CloseButtonRollover } from '../../shared/svg/components';
import { currencyFormatter } from '../../utils/currencyFormatter';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import { PriceUtility } from '../../utilities/PriceUtility';

const SummarySectionsListMobile = () => {
  const {
     settings, sections, totalPrice, isSummaryOpened, summaryShots, user, isPublic, vat, categories,
  } = useSelector(state => state.configurator);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const dispatch = useDispatch();

    const isUserLoggedIn = () => user !== null && user.isLoggedIn;

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    // dispatch(initializeSections());

    if (summaryShots != null && summaryShots.length === 2) {
      setTopShot(summaryShots[0]);
      setBottomShot(summaryShots[1]);
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  return (
    <div className={`summary-sections-list-mobile ${isUserLoggedIn() ? ' logged-in' : ''}`}>
      <div className="container-images">
        <div className="left-image">
          {topShot !== null && (
          <img src={`${settings.shots_base_url}/${topShot}.jpg`} alt="" />
                  )}
        </div>

      </div>
      <button className="close-button" type="button" onClick={() => dispatch(changeIsSummaryOpened(false))}>
        <CloseButton className="close-default" />
      </button>
      <div className="container-header">
        <div className="summary-sections-list-header">
          <div className="title">
            {TranslationUtility.GetFormattedMessageForUI('ui-printing-summary-your-configuration',
                  'Su configuración')}
          </div>
        </div>
        <div className="description">
          {TranslationUtility.GetFormattedMessageForUI('ui-summary-panel-subtitle',
                'A continuación se muestra un resumen de las opciones que ha seleccionado:')}
        </div>
      </div>
      <div className={`container-sections${user !== null && user.isLoggedIn ? ' logged-in' : ''}`}>
        {sections !== undefined && sections.map((section, index) => (
          <>
            <SummarySectionTitle section={section} includesPrices={false} />
            <div>
              {
                section.categories.map((category, index2) => {
                    if (category.features !== undefined && category.features.length > 0) {
                        return (
                          <SummaryFeature
                            categoryName={TranslationUtility.GetFormattedMessageForCategoryName(category)}
                            feature={category.features.find(feature => feature.id === category.selected_feature)}
                            disabled={category.disabled}
                          />
                        );
                    }
                    return null;
                })
              }
            </div>
          </>
            ))}
      </div>
      {vat.public_prices_enabled !== false && vat.public_prices_total_price_enabled !== false && (
      <div className={`total-price-summary-container${vat.vat_enabled ? ' vat-enabled' : ''}`}>
        <div className="divider" />
        {!IsNullOrUndefined(vat) && !vat.vat_breakdown_disabled
                ? (
                  <div className="total-price-exc-vat-row">
                    <div className="title">
                      {TranslationUtility.GetFormattedMessageForUI('ui-summary-total-price-excl-vat',
                                'TOTAL OPCIONES (sin IVA)')}
                    </div>
                    <div className="value">{currencyFormatter.format(totalPrice)}</div>
                  </div>
                ) : null}
        {!IsNullOrUndefined(vat) && vat.vat_enabled && !vat.vat_breakdown_disabled
                ? (
                  <div className="vat-row">
                    <div className="title">
                      {TranslationUtility.GetFormattedMessageForUI('ui-summary-vat',
                                'IVA')}
                    </div>
                    <div className="value">
                      {currencyFormatter.format(PriceUtility.calculateVatValue(categories, vat))}
                    </div>
                  </div>
                ) : null}
        {!IsNullOrUndefined(vat) && vat.vat_enabled
                ? (
                  <div className="total-price-inc-vat-row">
                    <div className="title">
                      {TranslationUtility.GetFormattedMessageForUI('ui-summary-total-price-incl-vat',
                                'PRECIO TOTAL OPCIONES (con IVA)')}
                    </div>
                    <div className="value">
                      {currencyFormatter.format(PriceUtility.calculateTotalPriceIncVat(categories, vat))}
                    </div>
                  </div>
                ) : null}
      </div>
      )}
    </div>
  );
};

export default SummarySectionsListMobile;
